import { AccessLevel, ApiAuthMethod } from 'libs/cms/common/types';

export const isPartnerResource = (accessLevel: AccessLevel) =>
  accessLevel === 'partner';

export const usesAuthorizationCodeFlow = (apiAuthMethod: ApiAuthMethod) =>
  apiAuthMethod === 'authorization-code';

export const webhookExist = (features: string[]) =>
  features.includes('webhooks');
